import { MenuItem } from 'prosemirror-menu';
import { NodeType, Schema } from 'prosemirror-model';
import { EditorState, TextSelection } from 'prosemirror-state';

const canInsert = (state: EditorState, nodeType: NodeType) => {
  const $from = state.selection.$from;
  for (let d = $from.depth; d >= 0; d--) {
    const index = $from.index(d);
    if ($from.node(d).canReplaceWith(index, index, nodeType)) {
      return true;
    }
  }
  return false;
};

const decorationItem = (nodeType: NodeType, options) => {
  return new MenuItem({
    ...options,
    label: options.label || ' ',
    enable: state => canInsert(state, nodeType),
    run: (state, dispatch) => {
      let tr = state.tr;
      tr = tr.replaceSelectionWith(nodeType.create());
      tr = tr.setSelection(
        TextSelection.create(tr.doc, tr.selection.to, tr.selection.to),
      );
      dispatch(tr);
    },
  });
};

export function decorationsMenu(schema: Schema) {
  return [
    decorationItem(schema.nodes.horizontal_rule, {
      title: 'Horizontal line',
      class: 'ProseMirror-icon-hr',
    }),
  ];
}
